import React from 'react'
import styled from 'styled-components'
import {
  BaseResponsiveDropdownProps,
  Dropdown,
  RadioButton,
  Tooltip,
  useResponsiveDropdown,
} from '@sketch/components'

import { ReactComponent as SortIconSvg } from '@sketch/icons/arrow-up-down-24'

import { SortDirection, useInboxSearchContext } from './InboxSearchContext'
import { InboxHeaderButton } from './Inbox.styles'

const SortIcon = styled(SortIconSvg)`
  height: 24px;
  width: 24px;
`

const SortRadio = styled(RadioButton)`
  margin: 0;
`

const SORT_OPTIONS: { value: SortDirection; label: string }[] = [
  { value: 'newest', label: 'Newest first' },
  { value: 'oldest', label: 'Oldest first' },
]

const SortDropdown = (_: BaseResponsiveDropdownProps) => {
  const { sort, setSort } = useInboxSearchContext()

  return (
    <>
      <Dropdown.Header>Sort by</Dropdown.Header>
      {SORT_OPTIONS.map(option => (
        <Dropdown.Item key={option.value}>
          <SortRadio
            name="inbox-sort"
            label={option.label}
            checked={sort === option.value}
            onChange={() => setSort(option.value)}
          />
        </Dropdown.Item>
      ))}
    </>
  )
}

export const InboxSortMenu = () => {
  const { sort } = useInboxSearchContext()
  const [content, buttonProps, { visible }] = useResponsiveDropdown({
    dropdown: SortDropdown,
    placement: 'bottom-start',
    usePortal: true,
  })

  const isActive = visible || sort !== 'newest'

  return (
    <>
      <Tooltip
        content="Sort"
        placement="bottom"
        disabled={visible}
        disableWhenTouchDevice
      >
        <InboxHeaderButton
          {...buttonProps}
          aria-label="Sort"
          $isActive={isActive}
        >
          <SortIcon />
        </InboxHeaderButton>
      </Tooltip>
      {content}
    </>
  )
}
